import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AccordionComponent, AccordionPanelDirective, SpinnerComponent } from '@libs/common/components';
import { AuthDebuggerComponent, AuthDebuggerService } from './auth';
import { DebuggerAuthState, DebuggerPageState } from './debugger.model';
import { PageDebuggerComponent, PageDebuggerService } from './page';

@Component({
  selector: 'ui-debugger',
  templateUrl: './debugger.component.html',
  styleUrls: ['./debugger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AccordionComponent,
    AccordionPanelDirective,
    PageDebuggerComponent,
    AuthDebuggerComponent,
    SpinnerComponent,
  ],
})
export class DebuggerComponent {
  public auth: Signal<DebuggerAuthState | undefined> = toSignal(this.authDebugger.getAuthState());
  public page: Signal<DebuggerPageState | undefined> = toSignal(this.pageDebugger.getPageState());
  public isUpdating: Signal<boolean | undefined> = toSignal(this.authDebugger.getIsUpdating());

  public isAuthenticated: Signal<boolean> = computed(() => Boolean(this.auth()?.token));
  public status: Signal<string> = computed(() => {
    return this.isUpdating()
      ? 'Updating...'
      : `Customer ${this.auth()?.customerNumber} (${this.page()?.bffEnv}, ${this.isAuthenticated() ? 'authenticated' : 'anonymous'})`;
  });

  public constructor(
    private readonly authDebugger: AuthDebuggerService,
    private readonly pageDebugger: PageDebuggerService,
  ) {
  }
}
